// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import RedebitListPagingResultModel from '../../model/redebit-list-paging-result-model';
import RedebitListPagingResultDTO from '../dto/redebit-list-paging-result-dto';
import dtoSchema from '../schemas/redebit-list-paging-result-schema';
import RedebitListModel from '../../model/redebit-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class RedebitListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<RedebitListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => RedebitListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: RedebitListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<RedebitListPagingResultDTO>): RedebitListPagingResultModel;
  static toModel(dto: DeepPartial<RedebitListPagingResultDTO> | undefined | null): RedebitListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<RedebitListPagingResultDTO> | undefined | null): RedebitListPagingResultModel | undefined {
    return dto ? new RedebitListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<RedebitListPagingResultModel> | RedebitListPagingResultModel): RedebitListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as RedebitListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for RedebitListPagingResultModel, can not map to RedebitListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
